import api from '@/services/api'

export default {
    state: {
        KRs: [],
        OKRs: [],
        AllOKRs: [],
        OkrsDashData: {},
        AllOkrsDashData: {},
        InitiativesDashData: {},
    },
    mutations: {
        SET_KRs(state, KRs) {
            state.KRs = KRs
        },
        SET_OKRs(state, OKRs) {
            state.OKRs = OKRs
        },
        SET_ALL_OKRs(state, OKRs) {
            state.AllOKRs = OKRs
        },
        SET_OKRS_DASH_DATA(state, dashData) {
            state.OkrsDashData = dashData
        },
        SET_ALL_OKRS_DASH_DATA(state, dashData) {
            state.AllOkrsDashData = dashData
        },
        SET_INITIATIVES_DASH_DATA(state, dashData) {
            state.InitiativesDashData = dashData
        },
    },
    actions: {
        getKRsFromAPI({ commit, rootState }) {
            const userID = rootState.profile.currentUserID
            return api
                .get('objectives/all/keyresults', {
                    params: {
                        and: 'yes',
                        search: `user_id:${userID}`,
                        with: 'user;objective.period;last_checkin',
                    },
                })
                .then((resp) => {
                    commit('SET_KRs', resp.data.data)
                })
        },
        async getAllOKRsFromAPI({ commit, rootGetters }, { page, perPage, filters }) {
            const periods = await rootGetters.periods
            let search
            let searchFields

            if (filters.search_string) {
                search = `title:${filters.search_string.trim()};key_results.title:${filters.search_string.trim()};key_results.initiatives.title:${filters.search_string.trim()};`
                searchFields = `title:like;key_results.title:like;key_results.initiatives.title:like;`
            }

            return api
                .get('objectives', {
                    params: {
                        all_okrs: true,
                        with: 'period;user;ancestors;descendants;children;key_results.user;key_results.last_checkin;key_results.checkins;key_results.initiatives.user;section;',
                        append: 'key_results_permissions,update_permission,duplicate_permission,request_collaboration_permission,delete_permission',
                        sortedBy: 'asc',
                        orderBy: 'level',
                        search,
                        searchFields,
                        page,
                        per_page: perPage,
                        periods,
                        sections_ids: filters.sections_ids,
                        levels: filters.levels,
                        users_ids: filters.users_ids,
                    },
                })
                .then((resp) => {
                    let { data, total } = resp.data.data
                    let { dash_data } = resp.data

                    commit('SET_ALL_OKRs', data)
                    commit('SET_ALL_OKRS_DASH_DATA', dash_data)
                    commit('SET_INITIATIVES_DASH_DATA', dash_data.initiatives_dashboard)

                    return total
                })
        },
        async getOKRsFromAPI({ commit, rootGetters }) {
            let periods = await rootGetters.periods
            const user_id = await rootGetters['profile/currentProfileUserID']

            return api
                .get('objectives', {
                    params: {
                        users_ids: [user_id],
                        profile_okrs: periods.length ? 1 : 0,
                        search: `user_id:${user_id};key_results.user_id:${user_id};key_results.initiatives.user_id:${user_id}`,
                        periods,
                        with: 'period;user;ancestors;descendants;children;key_results.user;key_results.last_checkin;key_results.checkins;key_results.initiatives.user;section;',
                        append: 'key_results_permissions,update_permission,duplicate_permission,request_collaboration_permission,delete_permission',
                        sortedBy: 'asc',
                        orderBy: 'level',
                    },
                })
                .then((resp) => {
                    let { data, dash_data } = resp.data

                    commit('SET_OKRs', data)
                    commit('SET_OKRS_DASH_DATA', dash_data)
                    commit('SET_INITIATIVES_DASH_DATA', dash_data.initiatives_dashboard)
                })
        },
    },
    getters: {
        getKRs: (state, rootState) => {
            const selectedPeriodsIDs = rootState.periods
            if (selectedPeriodsIDs) {
                return state.KRs.filter((kr) => selectedPeriodsIDs.includes(kr.objective.period_id))
            }
            return state.KRs
        },
        getOKRs: (state) => {
            return state.OKRs
        },
        getAllOKRs: (state) => {
            return state.AllOKRs
        },
        getOkrsDashData: (state) => {
            return state.OkrsDashData
        },
        getAllOkrsDashData: (state) => {
            return state.AllOkrsDashData
        },
        getInitiativesDashData: (state) => {
            return state.InitiativesDashData
        },
    },
}
